"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionSelect = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var controlled_1 = require("../form/controlled");
var dropdown_1 = require("../dropdown");
var RegionOption_1 = require("./RegionOption");
var get_props_from_children_by_type_1 = require("../_util/get-props-from-children-by-type");
var config_context_1 = require("../_util/config-context");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var i18n_1 = require("../i18n");
var RegionPanel_1 = require("./RegionPanel");
var call_both_1 = require("../_util/call-both");
exports.RegionSelect = forward_ref_with_statics_1.forwardRefWithStatics(function RegionSelect(props, ref) {
    var _a;
    var t = i18n_1.useTranslation();
    var classPrefix = config_context_1.useConfig().classPrefix;
    var _b = tslib_1.__read(react_1.useState(false), 2), open = _b[0], setOpen = _b[1];
    // eslint-disable-next-line react/destructuring-assignment
    var options = react_1.useMemo(function () { return get_props_from_children_by_type_1.getPropsFromChildrenByType(props.children, RegionOption_1.RegionOption); }, [props.children]);
    var columns = react_1.useMemo(function () { return get_props_from_children_by_type_1.getPropsFromChildrenByType(props.children, RegionPanel_1.RegionPanel.Column); }, [props.children]);
    var _c = controlled_1.useDefaultValue(props, (_a = options[0]) === null || _a === void 0 ? void 0 : _a.value), value = _c.value, onChange = _c.onChange, moreInfo = _c.moreInfo, children = _c.children, disabled = _c.disabled, shortcut = _c.shortcut, dropdownProps = tslib_1.__rest(_c, ["value", "onChange", "moreInfo", "children", "disabled", "shortcut"]);
    var shortcutContent = react_1.useMemo(function () {
        if (shortcut === null || shortcut === void 0 ? void 0 : shortcut.cacheKey) {
            var shortcutOptions = [];
            try {
                shortcutOptions = JSON.parse(localStorage.getItem(shortcut.cacheKey) || "[]");
            }
            catch (_) {
                // ignore
            }
            return tslib_1.__assign(tslib_1.__assign({ title: t.recentlyVisited }, shortcut), { options: shortcutOptions
                    .map(function (value) { return options.find(function (x) { return x && x.value === value; }); })
                    .filter(Boolean)
                    .slice(0, (columns === null || columns === void 0 ? void 0 : columns.length) || 1) });
        }
        if (shortcut === null || shortcut === void 0 ? void 0 : shortcut.options) {
            return tslib_1.__assign(tslib_1.__assign({ title: t.recentlyVisited }, shortcut), { options: shortcut.options
                    .map(function (value) { return options.find(function (x) { return x && x.value === value; }); })
                    .filter(Boolean) });
        }
        return null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columns, options, shortcut, t.recentlyVisited, open]);
    var selectedOption = options.find(function (x) { return x && x.value === value; }) || options[0];
    return (react_1.default.createElement(dropdown_1.Dropdown, tslib_1.__assign({ ref: ref }, dropdownProps, { boxAdaptable: true, appearance: "button", className: classnames_1.default(classPrefix + "-dropdown--region-select", dropdownProps.className), disabled: disabled, clickClose: false, onOpenChange: call_both_1.callBoth(dropdownProps.onOpenChange, function (open) {
            return setOpen(open);
        }), button: react_1.default.createElement(react_1.default.Fragment, null,
            selectedOption && react_1.default.createElement(RegionOption_1.RegionOption, tslib_1.__assign({}, selectedOption)),
            moreInfo && (react_1.default.createElement("div", { className: classPrefix + "-region__more" }, moreInfo))) }), function (close) { return (react_1.default.createElement(RegionOption_1.RegionOptionContext.Provider, { value: {
            inject: function (props) {
                return tslib_1.__assign(tslib_1.__assign({}, props), { selected: value === props.value, onClick: function (event) {
                        if (typeof props.onClick === "function") {
                            props.onClick(event);
                        }
                        if (event.isDefaultPrevented()) {
                            return;
                        }
                        onChange(props.value, { event: event });
                        close();
                        if ((shortcut === null || shortcut === void 0 ? void 0 : shortcut.cacheKey) &&
                            typeof localStorage !== "undefined") {
                            var shortcutOptions = [];
                            try {
                                shortcutOptions = JSON.parse(localStorage.getItem(shortcut.cacheKey) || "[]");
                                localStorage.setItem(shortcut.cacheKey, JSON.stringify(tslib_1.__spread([
                                    props.value
                                ], shortcutOptions.filter(function (i) { return i !== props.value; })).slice(0, 12)));
                            }
                            catch (_) {
                                // ignore
                            }
                        }
                    } });
            },
            shortcut: shortcutContent,
        } }, children)); }));
}, {
    defaultLabelAlign: "middle",
});
exports.RegionSelect.displayName = "RegionSelect";
//# sourceMappingURL=RegionSelect.js.map